module.exports = __webpack_public_path__ + "static/media/opacity-icon.ed90c6bc.svg";